import { googleCalendarUrl } from '../../lib/calendar';
import { calendarState } from '../../lib/todos';

const DAY = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short' });

/* Add to Google Calendar.
 *
 * A pre-filled template link, not an integration: it opens Google with the
 * event filled in and the person presses Save. The app never learns whether
 * they did, which is why `added_to_calendar_at` is treated as a hint about
 * the button's appearance and never as proof the event exists.
 *
 * The link is also one-way: it cannot move an event already saved. So when
 * the due date changes after adding, the button says so instead of letting
 * the calendar quietly disagree with the dashboard.
 */
export default function CalendarButton({ task, variant = 'icon', onAdded }) {
  const url = googleCalendarUrl(task, window.location.origin);
  // No due date, no event worth making.
  if (!url) return null;

  const state = calendarState(task);
  const added = state === 'added';
  const stale = state === 'stale';

  const label = stale
    ? 'Date changed — re-add to calendar'
    : added
      ? `Added · ${DAY.format(new Date(task.added_to_calendar_at))}`
      : 'Add to Google Calendar';

  const className =
    variant === 'icon'
      ? 'task-calendar-icon' + (stale ? ' stale' : added ? ' added' : '')
      : 'ghost-button task-calendar-button' + (stale ? ' stale' : '');

  return (
    <a
      className={className}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={label}
      aria-label={label}
      onClick={() => onAdded && onAdded()}
    >
      {variant === 'icon' ? (
        <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
          <rect x="2" y="3" width="12" height="11" rx="2" />
          <path d="M2 6.5h12M5.5 1.75v2.5M10.5 1.75v2.5" strokeLinecap="round" />
          {stale && <path d="M6 10.5h4M8 8.5v4" strokeLinecap="round" />}
        </svg>
      ) : (
        <>
          {stale && '⟳ '}
          {label}
        </>
      )}
    </a>
  );
}
